import { render } from "./putting.vue?vue&type=template&id=303ed775"
import script from "./putting.vue?vue&type=script&lang=js"
export * from "./putting.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__